import * as $ from "jquery";

export interface IDragSource {
    onDragComplete: () => void;
    getDragItem?: () => any;
    getDragImage?: (dragType: string) => IDragImage;
}
export interface IDragImage {
    img: Element;
    x: number;
    y: number;
}
export interface IDropTarget {
    allowDrop(dragType: string, effectAllowed: string): string;
    onDrop(drop: IDrop): boolean;
    getDropElement?():HTMLElement;
}
export interface IDrop {
    dragType: string;
    value: any;
    targetX: number;
    targetY: number;
    dragSource: IDragSource;
    dragImage?: IDragImage;
}
export class Dnd {
    public static move = "move";
    //private static dragSource: IDragSource;
    private static currentDrop: IDrop;
    static dragStart(event: React.DragEvent<HTMLElement>, dragSource: IDragSource, dragType: string, effectsAllowed: string) {
        //if items are already being dragged, skip (event must have bubbled)
        if (event.dataTransfer.items.length)
            return;
        Dnd.currentDrop = {
            dragSource: dragSource,
            dragType: dragType.toLowerCase(),
            value: null,
            targetX: 0,
            targetY: 0
        };
        //Dnd.dragSource = dragSource;
        const dragTypeLc = dragType.toLowerCase();
        //console.log("dragStart:" + dragTypeLc + ":" + dragType);
        event.dataTransfer.setData("dnd/" + dragTypeLc, dragType);
        event.dataTransfer.effectAllowed = effectsAllowed;

        if (dragSource.getDragImage) {
            const dragImage = dragSource.getDragImage(dragType);
            if (dragImage) {
                Dnd.currentDrop.dragImage = dragImage;
                let scale = 1;
                if (window.devicePixelRatio) {
                    scale = window.devicePixelRatio;
                }
                event.dataTransfer.setDragImage(dragImage.img, dragImage.x * scale, dragImage.y * scale);
            }
        }
    }

    static dragOver(event: React.DragEvent<HTMLElement>, dropTarget: IDropTarget) {
        //do not drag to self
        if ((dropTarget as object) === (Dnd.currentDrop.dragSource as object))
            return;

        for (let i = 0; i < event.dataTransfer.items.length; i++) {
            const type = event.dataTransfer.items[i].type;
            //console.log("dragOver:" + type);
            if (type.startsWith("dnd/")) {
                const dragType = type.substr(4);
                const dropEffect = dropTarget.allowDrop(dragType, event.dataTransfer.effectAllowed);
                if (dropEffect) {
                    event.dataTransfer.dropEffect = dropEffect;
                    //console.log("Drag over component " + this.id + ": Drag started on component " + TokenComponent.currentDraggedComponent.id);
                    event.preventDefault();
                    //console.log("dragOver:ok");
                }
                return;
            }
        }
    }
    static drop(event: React.DragEvent<HTMLElement>, dropTarget: IDropTarget) {
        //no dnd in progress
        if (!Dnd.currentDrop) return;
        //do not drag to self
        if ((dropTarget as object) === (Dnd.currentDrop.dragSource as object))
            return;
        let dropped: boolean = false;
        let dropTargetElement:any=null;
        if (dropTarget.getDropElement) {
            dropTargetElement = dropTarget.getDropElement();
        }
        if (!dropTargetElement) {
            dropTargetElement = event.target;
        }

        const offset = $(dropTargetElement).offset();
        const targetX = event.pageX - offset.left;
        const targetY = event.pageY - offset.top;
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
            const type = event.dataTransfer.items[i].type;
            if (type.startsWith("dnd/")) {
                const dragType = type.substr(4);
                const dropEffect = dropTarget.allowDrop(dragType, event.dataTransfer.effectAllowed);
                if (dropEffect) {
                    try {
                        let drop = Dnd.currentDrop;

                        if (drop.dragSource.getDragItem) {
                            drop.value = drop.dragSource.getDragItem();
                        }
                        drop.targetX = targetX;
                        drop.targetY = targetY;
                        if (drop.dragImage) {
                            drop.targetX -= drop.dragImage.x;
                            drop.targetY -= drop.dragImage.y;
                        }
                        if (dropTarget.onDrop(drop)) {
                            dropped = true;
                            drop.dragSource.onDragComplete();
                        } else {
                            console.log("Drop rejected by target");
                        }
                    } catch (e) {
                        console.log("Failed drop: " + e);
                    }
                } else {
                    return;
                }
            }
        }
        if (dropped) {
            Dnd.currentDrop = null;
            event.preventDefault();
        }
    }

}